import { render, staticRenderFns } from "./MainSearchResaults.vue?vue&type=template&id=0256a3d2&"
import script from "./MainSearchResaults.vue?vue&type=script&lang=js&"
export * from "./MainSearchResaults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports